module.exports = __webpack_public_path__ + "static/media/furious.ed2bfbcc.svg";